import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { BatchBranchService } from './batchbranch.service';
import { IProjectRepo } from '../shared/projectRepo';
import { formatDate } from '@angular/common';
import { IBranch } from '../shared/branch';
import * as auth from '../auth-config.json';
import { Account } from '../shared/account';

@Component({
  selector: 'app-batchbranch',
  templateUrl: './batchbranch.component.html',
  styleUrls: ['./batchbranch.component.css']
})
export class BatchbranchComponent implements OnInit {

  public batchBranchForm: FormGroup;
  public projectRepos: IProjectRepo[];
  public projectList: { name: string, group: string }[] = [];
  public branchName: string = "release/release-" + (formatDate(new Date(), 'yyyy-MMdd', 'en-US'));
  public created: string = "";
  public error: string = "";
  public message: string = "You must login to view this page.";
  loginDisplay = false;
  public selectedFilter: string = '';

  get filterOptions(): string[] {
    const standard = this.projectList
      .filter(p => p.group === 'standard')
      .map(p => p.name);
    return ['All', 'CamAcct', 'Connect + Related', ...standard];
  }

  get filteredProjectRepos(): IProjectRepo[] {
    if (!this.projectRepos || !this.selectedFilter) return [];
    return this.projectRepos;
  }

  constructor(private data: BatchBranchService, private spinner: NgxSpinnerService, private router: Router,
      private fb: FormBuilder, private authService: MsalService, private msalBroadcastService: MsalBroadcastService)
  {
    this.batchBranchForm = this.fb.group({
      reposArray: this.fb.array([])
    });
  }


  ngOnInit() {
    this.handleSecurity();
    this.data.loadProjectList().subscribe(list => {
      this.projectList = list;
    });
  }

  onFilterChange(filter: string) {
    if (!filter) return;
    this.selectedFilter = filter;

    const reposArray: FormArray = this.batchBranchForm.get('reposArray') as FormArray;
    while (reposArray.length) reposArray.removeAt(0);

    const cached = this.data.isCached(filter);
    if (!cached) {
      this.projectRepos = null;
      this.spinner.show();
    }

    this.data.loadProjectsAndRepos(filter)
      .subscribe(data => {
        this.projectRepos = data;
        if (!cached) this.spinner.hide();
      });
  }

  handleSecurity() {
    
    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          console.log(result);
        }
        // Sets login display when using redirects
        this.setLoginDisplay();
      },
      error: (error) => console.log(error)
    });

    // Sets login display when using popups
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {

    let allowedRoles = [auth.roles.BuildManager];

    let accounts: AccountInfo[] = this.authService.instance.getAllAccounts();
    let account: Account = accounts[0];

    this.loginDisplay = accounts.length > 0;

    if (this.loginDisplay && !allowedRoles.includes(account.idTokenClaims?.roles[0])) {
      this.loginDisplay = false;
      this.message = 'You do not have the correct permissions to view this page.';
    }

  }

  onCheckboxChange(e) {
    const reposArray: FormArray = this.batchBranchForm.get('reposArray') as FormArray;

    if (e.target.checked) {
      reposArray.push(new FormControl(e.target.value));
    } else {
      let i: number = 0;
      reposArray.controls.forEach((item: FormControl) => {
        if (item.value == e.target.value) {
          reposArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  trackByProject(index: number, p: IProjectRepo): string { return p.name; }
  trackByRepo(index: number, r: any): string { return r.id; }

  cancel() {
    this.router.navigate(['/'])
  }

  CreateBranchesFromForm() {
    this.spinner.show();
    this.created = "";
    this.error = "";

    const reposArray: FormArray = this.batchBranchForm.get('reposArray') as FormArray;
    let counter = 1;

    for (let control of reposArray.controls) {

      var ary = control.value.split("|");

      this.CreateBranch(ary, this.branchName, counter == reposArray.length);

      counter++;

    }
  }

  CreateBranch(ary: any, branch: string, done: boolean = false) {
    let counter = 0;
    let dto: IBranch = {
      name: branch,
      repositoryId: ary[1],
      projectName: ary[0],
      baseBranch: ary[3] || 'develop'
    };

    this.data.createBatchBranches(dto)
      .subscribe(result => {
        var message = ary[0] + '-' + ary[2] + '-' + branch + ', ';
        if (!result.success) {
          if (counter == 0)
            this.error += "Error creating branch(es): ";

          this.error += message;
          counter++;
        }
        else
          this.created += message;

       if (done)
         this.spinner.hide();
      });
  }
}
